import React from "react";

const NoData = () => {
  return <div className="no-data">No data</div>;
};

export default NoData;
